package app

data class ImageFit(
    val scale: Double,
    val width: Double,
    val height: Double,
    val offsetX: Double,
    val offsetY: Double
)

fun browserNumber(value: dynamic): Double = value.unsafeCast<Double>()

const val MinZoom = 0.1
const val MaxZoom = 5.0

fun fitImage(imageWidth: Double, imageHeight: Double, canvasWidth: Double, canvasHeight: Double): ImageFit {
    val scale = minOf(canvasWidth / imageWidth, canvasHeight / imageHeight)
    val width = imageWidth * scale
    val height = imageHeight * scale
    return ImageFit(
        scale = scale,
        width = width,
        height = height,
        offsetX = (canvasWidth - width) / 2.0,
        offsetY = (canvasHeight - height) / 2.0
    )
}

fun toCanvasPoint(
    screenX: Double,
    screenY: Double,
    canvasLeft: Double,
    canvasTop: Double,
    displayScaleX: Double,
    displayScaleY: Double
): Point {
    return Point(
        x = (screenX - canvasLeft) * displayScaleX,
        y = (screenY - canvasTop) * displayScaleY
    )
}

fun toImagePoint(
    screenX: Double,
    screenY: Double,
    canvasLeft: Double,
    canvasTop: Double,
    fit: ImageFit,
    view: ViewState,
    displayScaleX: Double,
    displayScaleY: Double
): Point {
    val canvasPoint = toCanvasPoint(screenX, screenY, canvasLeft, canvasTop, displayScaleX, displayScaleY)
    return Point(
        x = (canvasPoint.x - view.offsetX) / view.zoom - fit.offsetX,
        y = (canvasPoint.y - view.offsetY) / view.zoom - fit.offsetY
    )
}

fun zoomAroundCanvasPoint(view: ViewState, canvasPoint: Point, nextZoom: Double): ViewState {
    val clampedZoom = nextZoom.coerceIn(MinZoom, MaxZoom)
    val contentX = (canvasPoint.x - view.offsetX) / view.zoom
    val contentY = (canvasPoint.y - view.offsetY) / view.zoom
    return ViewState(
        zoom = clampedZoom,
        offsetX = canvasPoint.x - contentX * clampedZoom,
        offsetY = canvasPoint.y - contentY * clampedZoom
    )
}

fun boundsOf(path: List<Point>): BlurArea {
    val minX = path.minOf { it.x }
    val minY = path.minOf { it.y }
    val maxX = path.maxOf { it.x }
    val maxY = path.maxOf { it.y }
    return BlurArea(
        id = "preview",
        x = minX,
        y = minY,
        width = maxX - minX,
        height = maxY - minY,
        shape = BlurShape.Freehand,
        blurRadius = 1,
        path = path
    )
}
